import { maxProductQuantity } from '@/features/pos/components/ProductConfigurationModal/form/constants'
import { FormAddonGroup } from '@/features/pos/components/ProductConfigurationModal/form/types'
import { calcAddonsTotalQuantity } from '@/features/pos/components/ProductConfigurationModal/utils/calcAddonsTotalQuantity'
import { z } from 'zod'

const addonGroup: z.ZodType<FormAddonGroup> = z
    .object({
        id: z.string().nonempty(),
        type: z.union([z.literal('topping'), z.literal('product')]),
        addonQuantities: z.record(z.number().min(1)),
        minQuantity: z.number(),
    })
    .refine((addonGroup) => {
        const totalQuantity = calcAddonsTotalQuantity(addonGroup.addonQuantities)

        return totalQuantity >= addonGroup.minQuantity
    })

export const schema = z.object({
    productVariantId: z.string().nonempty(),
    quantity: z.number().int().min(1).max(maxProductQuantity),
    addonGroups: z.record(addonGroup).optional(),
    removedIngredients: z.record(z.boolean().optional()).optional(),
})
